import { Phone, Wrench, Tv, Crown, Headphones } from "lucide-react";
import { CallLink } from "./CallLink";
import { CallbackForm } from "./CallbackForm";

const chips = [
  { icon: Wrench, label: "Free Installation & Setup" },
  { icon: Tv, label: "600+ HD Channels" },
  { icon: Crown, label: "Premium Content Access" },
  { icon: Headphones, label: "24/7 Customer Support" },
];

export function Hero() {
  return (
    <section className="relative overflow-hidden" style={{ background: "var(--gradient-hero)" }}>
      <div className="absolute -top-32 -left-24 h-96 w-96 rounded-full bg-accent/30 blur-3xl" />
      <div className="absolute -bottom-32 -right-24 h-96 w-96 rounded-full bg-accent/20 blur-3xl" />
      <div className="relative mx-auto grid max-w-6xl gap-10 px-4 py-14 sm:py-20 lg:grid-cols-2 lg:gap-12 lg:py-24">
        <div className="text-primary-foreground">
          <span className="inline-flex items-center rounded-full border border-white/20 bg-white/10 px-3 py-1 text-xs font-medium uppercase tracking-wider backdrop-blur">
            New DTH connection · Same-day callback
          </span>
          <h1 className="mt-4 text-4xl font-black leading-tight tracking-tight sm:text-5xl lg:text-6xl">
            Get <span className="text-accent">DTH</span> New Connection
          </h1>
          <p className="mt-4 max-w-xl text-base text-white/80 sm:text-lg">
            Book a Tata Play DTH new connection. Check current offers, choose your set-top box and request doorstep
            installation where available.
          </p>

          <ul className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {chips.map(({ icon: Icon, label }) => (
              <li
                key={label}
                className="flex items-center gap-3 rounded-xl border border-white/15 bg-white/5 px-4 py-3 backdrop-blur"
              >
                <span className="grid h-9 w-9 place-items-center rounded-lg bg-accent text-accent-foreground">
                  <Icon className="h-4 w-4" />
                </span>
                <span className="text-sm font-medium">{label}</span>
              </li>
            ))}
          </ul>

          <div className="mt-8 flex flex-wrap gap-3">
            <CallLink
              location="hero"
              label="Hero Call Now"
              className="inline-flex items-center gap-2 rounded-full bg-accent px-6 py-3.5 text-base font-semibold text-accent-foreground shadow-[var(--shadow-glow)] transition hover:brightness-110"
            >
              <Phone className="h-4 w-4" /> Call Now: 6364894003
            </CallLink>
            <a
              href="#form"
              className="inline-flex items-center gap-2 rounded-full border border-white/30 px-6 py-3.5 text-base font-semibold text-primary-foreground transition hover:bg-white/10"
            >
              Request a callback
            </a>
          </div>
        </div>

        <div className="lg:pl-6">
          <CallbackForm />
        </div>
      </div>
    </section>
  );
}
